<div class=" w-full h-full overflow-hidden">
    <div class="flex flex-col h-8">
        <div class="flex justify-between mb-1">
            <h3 class="site-name-color">Select Chainage </h3>
            <span class="flex items-center "  (click)="closeDialogBox()"
                style="cursor: pointer">Close
                <mat-icon [svgIcon]="'custom:close'"  (click)="closeDialogBox()"></mat-icon>
            </span>
        </div>
    </div>
    <!-- <hr class="w-full my-4"> -->
    <div class="flex flex-col h-full w-full">
        <!-- <p>Chainges Value</p> -->
    <div class="flex justify-center flex-row w-full h-[93%]">
        <div class="w-full flex flex-col min-h-[100%]">
            <div class="relative sm:max-h-120 divide-y overflow-y-auto bg-card w-full h-full">
                <div class="flex flex-row border-t-2 w-full h-full" >

                    <div class=" w-2/5 border-r-2 h-full">
                        <div class=" flex flex-col w-full relative" style="top: 29px !important;">
                            <div class="w-full flex flex-col" style="width: 97% !important;">
                                <span class="w-full " style="height:44px !important;border-radius: 4px !important;" [ngClass]="chainageVal === selectedChaingeVal?'selectedChainage':''"
                                    *ngFor="let chainageVal of chainageValues;let i = index">
                                    <mat-checkbox class="py-2 pl-5 w-full" (change)="selecteChainageRange(chainageValues[i],i)" [checked]="isChecked(i)">
                                        <span (click)="onChainageValueClick(chainageVal,i)" class="w-full cursor-pointer">
                                            Chainage {{ i + 1 }}
                                        </span> 
                                    </mat-checkbox>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class=" w-3/5 overflow-auto h-full min-h-[272px]">
                        <div class=" flex flex-col ">
                            <div class="md:flex md:items-center mb-3" style="top: 10% !important;
                            left: 45% !important;
                            position: absolute !important;">
                                <div class="md:w-1/3">
                                    <label style="right: 24px !important;
                                    position: relative;" class="block md:text-right mb-1 md:mb-0 pr-4 text-gray-400" for="inline-password">
                                        From                
                                    </label>
                                    <div class="relative top-2" style="width: 375% !important;">
                                        <input step="0.05" [min]="selectedChaingeVal[0]" [max]="selectedChaingeVal[1]" 
                                        [value]="fromValue" (input)="minValueChange($event.target.value)" [ngClass]="minError ? 'bg-red-300  border-red-500':''"                         
                                            class="md:w-full h-10 rounded-xl bg-white appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white "
                                            id="inline-password" type="number" placeholder="">
                                    </div>
                                    <div class="md:w-2/5" >
                                    <label class="top-11 relative block md:text-right mb-1 md:mb-0 pr-4 text-gray-400" for="inline-password">
                                        To                
                                    </label>
                                    <div class="relative top-11" style="width: 950% !important;top: 50px !important;">
                                        <input step="0.05" [min]="selectedChaingeVal[0]" [max]="selectedChaingeVal[1]"
                                         [value]="toValue" (input)="maxValueChange($event.target.value)"   [ngClass]="maxError ? 'bg-red-300  border-red-500' : ''"                         
                                            class="md:w-full h-10 rounded-xl bg-white appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white "
                                            id="inline-password" type="number" placeholder="">
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class=" mb-4 mt-3 mr-4 flex justify-end">
                <button [ngStyle]="{'opacity': isFilterEnabled() ? '1' : '0.5' }" (click)="onChainageFilterClick()" class="bg-[#142653] hover:bg-[#0e1836] text-white font-bold py-2 px-4 rounded">
                    Filter
                </button>
            </div>
        </div>
    </div>
    </div>
</div>